import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Outlet, Navigate } from "react-router-dom";
import useAuth from "../Auth/useAuth";

const TeachersPage = () => {

  const {user, userType,logout } = useAuth();
const [menuOpen,setMenuOpen] = useState(false);

  if (!user) return <Navigate to={"/home"} />;

  if(userType==="admin" ||userType==="student"  )

  { logout();
   <Navigate to={"/home"}/>
  }

  // console.log(userType);

  const handleLogout=()=>{
    logout();
  window.location.reload(false)
  }


  return (
    <>
     {userType === 'teacher' &&
         <div className="flex  flex-row  sticky top-0   min-h-screen">
         <div className={`w-72 min-h-screen z-50 top-0  hidden md:block lg:block shadow-xl bg-white drop-shadow-2xl`}>
         <div className="h-10 md:h-16 text-center items-center justify-center z-50 bg-blue-900 sticky top-0 flex flex-wrap  text-4xl font-bold text-white">
        BISSS-8B
       </div>
           <div className="py-6 shadow-r-xl bg-white">
            <Link to={"/home"}>
             <div className="ml-4 mb-6 pr-4 bg-white rounded-full">
               <img
                className="w-32 rounded-full mx-auto hover:cursor-pointer"
                 src="../assets/as_logo.png"
                 alt="logo"
               />
             </div>
            </Link>
             <ul className="relative px-1">
            <Link to="teachersdashboard">
              <li className="relative pt-2">
                <div
                  className="flex items-center text-center py-3 px-10 rounded-lg overflow-hidden text-black text-ellipsis text-lg font-bold whitespace-nowrap shadow-md border-b-2 bg-white hover:text-gray-900 hover:bg-gray-300 hover:shadow-lg transition duration-300 ease-in-out"
                >
                  <span>Dashboard</span>
                </div>
              </li>
            </Link>
         
          <Link to="studentfield">
            <li className="relative pt-2">
              <div
                  className="flex items-center text-center py-3 px-10 rounded-lg overflow-hidden text-black text-ellipsis text-lg font-bold whitespace-nowrap shadow-md border-b-2 bg-white hover:text-gray-900 hover:bg-gray-300 hover:shadow-lg transition duration-300 ease-in-out"
              >
  
                <span>Students Attendance </span>
              </div>
            </li>
            </Link>
            {/* <Link to="teachersprofile">
            <li className="relative pt-2">
              <div
                  className="flex items-center text-center py-3 px-10 rounded-lg overflow-hidden text-black text-ellipsis text-lg font-bold whitespace-nowrap shadow-md border-b-2 bg-white hover:text-gray-900 hover:bg-gray-300 hover:shadow-lg transition duration-300 ease-in-out"
              >
  
                <span>Profile</span>
              </div>
            </li>
            </Link> */}
            <Link to="updatesyllabus">
            <li className="relative pt-2">
              <div
                  className="flex items-center text-center py-3 px-10 rounded-lg overflow-hidden text-black text-ellipsis text-lg font-bold whitespace-nowrap shadow-md border-b-2 bg-white hover:text-gray-900 hover:bg-gray-300 hover:shadow-lg transition duration-300 ease-in-out"
              >
  
                <span>Update Syllabus</span>
              </div>
            </li>
            </Link>
            {/* <Link to="showToppers">
            <li className="relative pt-2">
              <div
                  className="flex items-center text-center py-3 px-10 rounded-lg overflow-hidden text-black text-ellipsis text-lg font-bold whitespace-nowrap shadow-md border-b-2 bg-white hover:text-gray-900 hover:bg-gray-300 hover:shadow-lg transition duration-300 ease-in-out"
              >
  
                <span>Show Toppers</span>
              </div>
            </li>
            </Link> */}
            <Link to="resultShowTerm1">
            <li className="relative pt-2">
              <div
                  className="flex items-center text-center py-3 px-10 rounded-lg overflow-hidden text-black text-ellipsis text-lg font-bold whitespace-nowrap shadow-md border-b-2 bg-white hover:text-gray-900 hover:bg-gray-300 hover:shadow-lg transition duration-300 ease-in-out"
              >
  
                <span>show Result</span>
              </div>
            </li>
            </Link>
            <Link to="attendanceDetails">
            <li className="relative pt-2">
              <div
                  className="flex items-center text-center py-3 px-10 rounded-lg overflow-hidden text-black text-ellipsis text-lg font-bold whitespace-nowrap shadow-md border-b-2 bg-white hover:text-gray-900 hover:bg-gray-300 hover:shadow-lg transition duration-300 ease-in-out"
              >
  
                <span>Attendance Details</span>
              </div>
            </li>
            </Link>
          
          </ul>         
             </div>
        </div>
  
        <div
       className={`z-50 fixed top-10 shadow-xl px-[-50px] duration-300 ${
              menuOpen ? "w-64 h-0" : "w-0 h-0"
            }`}
        >
          <div
            className={`py-6 h-screen shadow-r-xl bg-white border-r-slate-300`}
          >
            <div className="ml-4 mb-6 bg-white rounded-full">
              <img
                className="w-32 rounded-full mx-auto hover:cursor-pointer"
                src="../assets/as_logo.png"
                alt="logo"
              />
            </div>
            <ul className="relative px-1">
            <Link to="teachersdashboard">
              <li className="relative pt-2">    
                <div className={`items-center rounded-lg overflow-hidden text-black text-ellipsis text-lg font-bold whitespace-nowrap  border-b-2 bg-white hover:text-gray-900 hover:bg-gray-300 hover:shadow-lg transition  ease-in-out   py-3 px-3  flex text-left  shadow-sm  hover:shadow-neutral-600 duration-300 ${
                       menuOpen ? "w-full" : "hidden"
                       }`}  >
                  <span>Dashboard</span>
                </div>
              </li>
            </Link>
            <Link to="studentfield">
              <li className="relative pt-2">    
                <div className={`items-center rounded-lg overflow-hidden text-black text-ellipsis text-lg font-bold whitespace-nowrap  border-b-2 bg-white hover:text-gray-900 hover:bg-gray-300 hover:shadow-lg transition  ease-in-out   py-3 px-3  flex text-left  shadow-sm  hover:shadow-neutral-600 duration-300 ${
                       menuOpen ? "w-full" : "hidden"
                       }`}  >
                  <span>Attendance</span>
                </div>
              </li>
            </Link>
            <Link to="teachersprofile">
              <li className="relative pt-2">    
                <div className={`items-center rounded-lg overflow-hidden text-black text-ellipsis text-lg font-bold whitespace-nowrap  border-b-2 bg-white hover:text-gray-900 hover:bg-gray-300 hover:shadow-lg transition  ease-in-out   py-3 px-3  flex text-left  shadow-sm  hover:shadow-neutral-600 duration-300 ${
                       menuOpen ? "w-full" : "hidden"
                       }`}  >
                  <span>Profile</span>
                </div>
              </li>
            </Link>
            {/* <Link to="updatesyllabus">
              <li className="relative pt-2">    
                <div className={`items-center rounded-lg overflow-hidden text-black text-ellipsis text-lg font-bold whitespace-nowrap  border-b-2 bg-white hover:text-gray-900 hover:bg-gray-300 hover:shadow-lg transition  ease-in-out   py-3 px-3  flex text-left  shadow-sm  hover:shadow-neutral-600 duration-300 ${
                       menuOpen ? "w-full" : "hidden"
                       }`}  >
                  <span>Update Syllabus</span>
                </div>
              </li>
            </Link> */}
            {/* <Link to="showToppers">
              <li className="relative pt-2">    
                <div className={`items-center rounded-lg overflow-hidden text-black text-ellipsis text-lg font-bold whitespace-nowrap  border-b-2 bg-white hover:text-gray-900 hover:bg-gray-300 hover:shadow-lg transition  ease-in-out   py-3 px-3  flex text-left  shadow-sm  hover:shadow-neutral-600 duration-300 ${
                       menuOpen ? "w-full" : "hidden"
                       }`}  >
                  <span>Show Toppers</span>
                </div>
              </li>
            </Link> */}
            {/* <Link to="resultShowTerm1">
              <li className="relative pt-2">    
                <div className={`items-center rounded-lg overflow-hidden text-black text-ellipsis text-lg font-bold whitespace-nowrap  border-b-2 bg-white hover:text-gray-900 hover:bg-gray-300 hover:shadow-lg transition  ease-in-out   py-3 px-3  flex text-left  shadow-sm  hover:shadow-neutral-600 duration-300 ${
                       menuOpen ? "w-full" : "hidden"
                       }`}  >
                  <span>Show Result</span>
                </div>
              </li>
            </Link> */}
         
          {/* <Link to="attendanceDetails">
            <li className="relative pt-2">
            <div className={`items-center rounded-lg overflow-hidden text-black text-ellipsis text-lg font-bold whitespace-nowrap  border-b-2 bg-white hover:text-gray-900 hover:bg-gray-300 hover:shadow-lg transition  ease-in-out   py-3 px-3  flex text-left  shadow-sm  hover:shadow-neutral-600 duration-300 ${
                  menuOpen ? "w-full" : "hidden"
                  }`}  >
  
                <span>Attendance Details </span>
              </div>
            </li>
            </Link> */}
          
          </ul>   
          </div>
        </div>
       
  
         <div className={`w-full z-50}`}>
           <div className=" py-auto  h-10 md:h-16 px-4 z-50 bg-blue-900 sticky top-0  text-xl font-bold text-white shadow-sm  duration-300">
             <div className="py-2 flex justify-between">
             <button className="mr-4 md:hidden" onClick={() => setMenuOpen(!menuOpen)}>
               <img  src="../assets/menu.png"
                  alt="pic"
                  className="h-6 w-8 mr-2 "
              />
            </button>
            <button
                className=" px-2 md:hidden font-bold text-white rounded-md hover:bg-[#e32f2f] active:bg-[#e32f2f] focus:outline-none focus:ring focus:ring-[#e32f2f]"
                onClick={handleLogout}
              >
                Logout
              </button>
             </div>
             <div className="flex  justify-between">
             <div className="hidden md:block font-bold">
              <span className="ml-5 text-white">{user?.email}</span>
            </div>
             <div className="hidden md:block">           
               <button
                className=" px-2 font-bold text-white rounded-md hover:bg-[#e32f2f] active:bg-[#e32f2f] focus:outline-none focus:ring focus:ring-[#e32f2f]"
                onClick={handleLogout}
              >
                Logout
              </button>
             </div>
             </div>
           </div>
           <div className="min-h-screen  bg-white text-center">
            <Outlet />
          </div>
          <div className="text-center  bg-[#072d59] px-4 py-4 ">
        <span className="text-black">© 2022 - </span>
        <span className="text-black font-semibold hover:text-white ">
          BISSS-8B
        </span>
        <span className="text-black">
          , Education Department, Bokaro Steel Plant
        </span>
      </div>
            </div>
      </div>
    } 
   </>
  );
};

export default TeachersPage;
